import { useStore, useStoreMap } from 'effector-react'
import { useMemo, MouseEvent } from 'react'
import Countdown from 'react-countdown'
import { BookingCarDrawer } from '~/entities/BookingCar'
import { driverModel } from '~/entities/Driver'
import {
  rentalContractModel,
  useRentalContractStatus,
} from '~/entities/RentalContract'
import { formatDateApiToLocalDateTimeForUi } from '~/shared/lib/date'
import { Button } from '~/shared/ui/Buttons'
import { useModal } from '~/shared/ui/Modal'
import { CancelBookingDrawer } from '../CancelBookingDrawer'
import {
  CancelBookingButton,
  Descriptions,
  Phone,
  Title,
  Wrapper,
  Timer,
} from './styled'

export function Booking() {
  const { isModalShow, closeModal, openModal } = useModal()
  const {
    isModalShow: isCancelBookingShow,
    closeModal: cancelBookingCloseModal,
    openModal: cancelBookingOpenModal,
  } = useModal()

  const rentalContract = useStore(rentalContractModel.$rentalContract)
  const cancellationFeeRub = rentalContract?.getCancellationFeeRub()

  const selectedRentalServices = rentalContract
    ?.getRentalServices()
    ?.filter((rentalService) => rentalService?.getIsEditForDriver())

  const timezone = useStoreMap(driverModel.$driver, (driver) =>
    driver?.getTimezone(),
  )

  const { isSigning, isSigned } = useRentalContractStatus()

  const location = useStoreMap(
    rentalContractModel.$rentalContract,
    (rentalContract) => rentalContract?.getCarLocation(),
  )

  const bookedUntil = useStoreMap(
    rentalContractModel.$rentalContract,
    (rentalContract) => rentalContract?.getBookedUntil(),
  )

  const targetDate =
    bookedUntil && timezone
      ? formatDateApiToLocalDateTimeForUi(bookedUntil, timezone)
      : null

  const timer = useMemo(
    () =>
      !!targetDate && (
        <Countdown
          date={new Date(targetDate)}
          onComplete={rentalContractModel.getRentalContractSilent}
          renderer={({ days, hours, minutes }) => (
            <div>
              <span>{days ? `${days} д. ` : ''}</span>
              <span>{hours} ч.</span> <span>{minutes} мин.</span>
            </div>
          )}
        />
      ),
    [targetDate],
  )

  const handleBookingCancel = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
    cancelBookingOpenModal()
  }

  return (
    <>
      <Button
        variant='limeFlooded'
        fullWidth
        onClick={openModal}
        style={{ '--border-radius': '12px' }}
        contentProps={{
          style: {
            display: 'flex',
            justifyContent: 'space-between',
            padding: '8px 8px 8px 16px',
            height: '54px',
          },
        }}
      >
        {timer}
        <div>Бронь</div>
        <CancelBookingButton
          {...(isSigning ? { onClick: handleBookingCancel } : {})}
        >
          Отменить
        </CancelBookingButton>
      </Button>
      <BookingCarDrawer
        isShow={isModalShow}
        onCancel={closeModal}
        location={location}
        cancellationFeeRub={cancellationFeeRub}
        rentalServices={selectedRentalServices}
      >
        <Timer>Ещё &nbsp;{timer}</Timer>

        {isSigning && (
          <Button
            size='large'
            fullWidth
            style={{
              marginBottom: '16px',
            }}
            to='/rental-contract-signing'
          >
            Подписать
          </Button>
        )}

        {isSigned && (
          <a style={{ textDecoration: 'none' }} href='tel:+79344770800'>
            <Wrapper>
              <Title>Отменить бронь по телефону</Title>
              <Phone>+7 (934) 477-08-00</Phone>
              <Descriptions>
                В Москве офис работает по будням 9:00–18:00 и в сб 10:00–16:00;
                в регионах — по будням 9:00–18:00, выходные — сб и вс.
              </Descriptions>
            </Wrapper>
          </a>
        )}
      </BookingCarDrawer>
      <CancelBookingDrawer
        isShow={isCancelBookingShow}
        onCancel={cancelBookingCloseModal}
      />
    </>
  )
}
